import { useQuery } from "@apollo/client";
import React from "react";
import { FetchPostgresViewer } from "types/gql-types";
import { apolloClient } from "data/graphql";
import Context, { Login } from "./context";
import { FETCH_POSTGRES_VIEWER } from "./query";

const Provider: React.FC = (props) => {
  const query = useQuery<FetchPostgresViewer>(FETCH_POSTGRES_VIEWER);
  if (query.loading || typeof query.data === "undefined") {
    return null;
  }

  return (
    <Login.Provider value={{ onLogin: () => {
      query.refetch();
      apolloClient.refetchQueries({ include: ["AppliedPropertyFeatures"] });
    } }}>
      <Context.Provider value={query.data.viewerPostgres}>{props.children}</Context.Provider>
    </Login.Provider>
  );
};

export default Provider;
